import AppCache from '../../utils/AppCache'
import config from '../config'
// import { Base64 } from 'js-base64'
const wx = require('weixin-js-sdk')
const $ = require('jquery')
import { recommendClick } from '@/apis/newdytapi/special-diseases-api'

const idCard = {
  verify(code) {
    const idCardReg = /^[1-9]\d{5}(19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i // 身份证格式正则表达式
    const idCard15Regex = /^[1-9]\d{5}(?!9{8})\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$/

    let isPass = true // 身份证验证是否通过（true通过、false未通过）

    // 如果身份证不满足格式正则表达式
    if (!code) {
      isPass = false
    } else if (!code.match(idCardReg) && !code.match(idCard15Regex)) {
      isPass = false
    } else if (code.length === 18) {
      // 18位身份证需要验证最后一位校验位
      code = code.split('')
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      let sum = 0
      let ai = 0
      let wi = 0
      for (let i = 0; i < 17; i++) {
        ai = parseInt(code[i])
        wi = factor[i]
        sum += ai * wi // 开始计算并相加
      }
      const last = parity[sum % 11] // 求余
      if (last.toString() !== code[17]) {
        isPass = false
      }
    } else if (code.length === 15) {
      let birDayCode = '19' + code.substring(6, 12)
      let res = this.checkBirthdayCode(birDayCode)
      if (!res) {
        isPass = false
      }

      /*
      // 校验15位身份证是否合法
      // 加权因子
      let factors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8]

      // 校验码对应值
      let codes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

      // 计算校验码
      let sum = 0
      for (let i = 0; i < code.length; i++) {
        sum += parseInt(code[i]) * factors[i]
      }
      let mod = sum % 11
      let checkCode = codes[mod]

      console.log(checkCode, code.charAt(14), 55555)
      // 检查校验码是否匹配
      if (code.charAt(14) !== checkCode) {
        isPass = false;
      } */
    }
    return isPass
  },
  checkBirthdayCode(birthdayCode) {
    let check = /^[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))$/.test(birthdayCode)
    if (!check) return false
    let yyyy = parseInt(birthdayCode.substring(0, 4), 10)
    let mm = parseInt(birthdayCode.substring(4, 6), 10)
    let dd = parseInt(birthdayCode.substring(6), 10)
    let xdata = new Date(yyyy, mm - 1, dd)
    if (xdata > new Date()) {
      return false //生日不能大于当前日期
    } else if (xdata.getFullYear() == yyyy && xdata.getMonth() == mm - 1 && xdata.getDate() == dd) {
      return true
    } else {
      return false
    }
  }
}
/**
 * @file
 * > 这是一个公用方法库文件.
 * @see {@link Utils}
 * @version 1.0.0
 * @author hejikun
 * @copyright hejikun 2017
 */
/**
 * @desc
 * > 这是一个公用方法库
 */
class Utils {
  cache = new AppCache()
  /**
   * **设置标题**
   * @function
   * @param {string} newTitle - 标题
   * @example
   * window.utils.setTitle('首页')
   * // vue组件中
   * this.utils.setTitle('首页')
   */
  setTitle(newTitle) {
    document.title = newTitle || '滇医通'
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      let iFrame = document.createElement('iframe')
      iFrame.src = '/static/change_title_aid.html'
      iFrame.style.display = 'none'
      iFrame.onload = function () {
        setTimeout(function () {
          iFrame.remove()
        }, 100)
      }
      document.body.appendChild(iFrame)
    }
  }
  /**
   * **判断一个元素是否进入可视区域**
   * @param {Element} overflowEle 溢出元素
   * @param {Element} wrapEle 包裹元素
   * @param {Element} visibleAreaEle 可视区域元素
   * @returns {Boolean} true(在可视区域内) | false(不在可视区域内)
   */
  enterVisualScope(overflowEle, wrapEle, visibleAreaEle) {
    let overflowEleHeight = $(overflowEle).height()
    let wrapEleScrollTop = $(wrapEle).scrollTop()
    let visibleAreaEleHeight = $(visibleAreaEle).height()
    if (wrapEleScrollTop + visibleAreaEleHeight > overflowEleHeight) {
      return true // 在可视区域内
    } else {
      return false // 不在可视区域内
    }
  }
  // 就诊顾问聊天可视区域内判断
  advEnterVisualScope(overflowEle, wrapEle, visibleAreaEle) {
    let overflowEleHeight = $(overflowEle).height()
    let wrapEleScrollTop = $(wrapEle).scrollTop()
    let visibleAreaEleHeight = $(visibleAreaEle).height()
    if (wrapEleScrollTop + visibleAreaEleHeight < overflowEleHeight) {
      return true // 在可视区域内
    } else {
      return false // 不在可视区域内
    }
  }
  /**
   * 生成 UUID，设计思路来源于 https://blog.csdn.net/mr_raptor/article/details/52280753 算法4
   * @param {Number} len UUID 长度
   * @param {Number} radix 使用多少进制数生成
   */
  genUUID(len, radix) {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    let uuid = []
    radix = radix || chars.length
    if (len) {
      for (let i = 0; i < len; i++) {
        uuid[i] = chars[0 | (Math.random() * radix)]
      }
    } else {
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'
      for (let i = 0; i < 36; i++) {
        if (!uuid[i]) {
          let r = 0 | (Math.random() * 16)
          uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
        }
      }
    }
    return uuid.join('')
  }
  weixinInit() {
    console.trace('start wx jssdk init')
    // let jsapiTicket = this.cache.getValue('jsapi_ticket', window.location.href)
    // if (jsapiTicket) {
    //   wx.config({
    //     debug: false,
    //     appId: jsapiTicket.appId,
    //     timestamp: jsapiTicket.timestamp,
    //     nonceStr: jsapiTicket.nonceStr,
    //     signature: jsapiTicket.signature,
    //     jsApiList: [
    //       'getLocation',
    //       'checkJsApi',
    //       'chooseWXPay',
    //       'closeWindow',
    //       'translateVoice',
    //       'startRecord',
    //       'stopRecord',
    //       'uploadVoice',
    //       'openLocation',
    //       'onMenuShareTimeline',
    //       'onMenuShareAppMessage',
    //       'onMenuShareQQ',
    //       'onMenuShareWeibo',
    //       'onMenuShareQZone',
    //       'hideMenuItems',
    //       'scanQRCode'
    //     ],
    //     openTagList: ['wx-open-launch-weapp'] // 跳转小程序时必填
    //   })
    //   document.addEventListener('WeixinOpenTagsError', function (e) {
    //     console.error(e.detail.errMsg) // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开发标签，JS-SDK其他功能不受影响
    //   })
    //   return
    // }
    // 获取微信方支付信息
    const time = new Date().getTime()
    // let authinfo = localStorage.getItem('authtoken')
    // let authDetail = JSON.parse(Base64.decode(authinfo.split('.')[1]))
    let url = ''
    let originUrl = window.location.href.split('#')[0]
    let firstHref = sessionStorage.getItem('firstHref')
    console.log('firstHref', firstHref)
    let isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    // 如果是IOS，jssdk的授权路径会是第一次打开网站的路径
    if(isIOS && firstHref){
      originUrl = firstHref.split('#')[0]
    }

    console.log(originUrl)
    // 昆华体检页面 获取jssign 默认 新公众号
    let effecientlyUseNewPay = false
    if(window.location.pathname.indexOf('/kunhua_physicalExamination') >= 0){
      effecientlyUseNewPay = true
    }
    
    if (config.useNewPay || effecientlyUseNewPay) {
      // if (authDetail.new_subscribe) {
      url = `https://vote.ynhdkc.com/wechat/api/v2/js-sign?t=${time}&url=${encodeURIComponent(originUrl)}`
    } else {
      url = `https://vote.ynhdkc.com/wechat/api/v1/js-sign?t=${time}&url=${encodeURIComponent(originUrl)}`
    }
    // window.axiosBaseApi.get(`/v1/wechat?t=${time}`).then((response) => {
    window.axiosBaseApi.get(url).then(async (response) => {
      if (response.data.code !== 1) {
        return
      }
      const jsapiTicket = response.data.data
      console.log(JSON.stringify(jsapiTicket))
      await this.cache.addCache('jsapi_ticket', originUrl, jsapiTicket, 900)
      // 滇医通新服务号：wx324860af71b94a93
      // 滇医通小程序：wx6fe267aca9b32a2f
      // 滇医通老服务号：wx337dd7b0a2de2ca4
      const wxPlatformMap = {
        'wx324860af71b94a93': '1', // 滇医通新服务号
        'wx6fe267aca9b32a2f': '2', // 滇医通小程序
        'wx337dd7b0a2de2ca4': '3', // 滇医通老服务号
      }
      localStorage.setItem('wxPlatform', wxPlatformMap[jsapiTicket.appId])
      wx.config({
        debug: false,
        appId: jsapiTicket.appId,
        timestamp: jsapiTicket.timestamp,
        nonceStr: jsapiTicket.nonceStr,
        signature: jsapiTicket.signature,
        jsApiList: [
          'getLocation',
          'checkJsApi',
          'chooseWXPay',
          'closeWindow',
          'translateVoice',
          'startRecord',
          'stopRecord',
          'uploadVoice',
          'openLocation',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'hideMenuItems',
          'scanQRCode',
          'chooseImage'
        ],
        openTagList: ['wx-open-launch-weapp', 'wx-open-subscribe'] // 跳转小程序时必填
      })
      wx.error(err => {
        console.log('DA-LANDPAGE:', localStorage.getItem('DA-LANDPAGE'))
        console.log('wx error:', err)
        const search = window.location.search
        if (!search.includes('&retry') && !search.includes('?retry') && process.env.NODE_ENV !== 'development' && !navigator.userAgent.includes('wechatdevtools')) {
          const href = window.location.href
          if (href.includes('?')) {
            window.location.href = window.location.href + '&retry=1'
          } else {
            window.location.href = window.location.href + '?retry=1'
          }
        }
      })
      document.addEventListener('WeixinOpenTagsError', function (e) {
        console.error(e.detail.errMsg) // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开发标签，JS-SDK其他功能不受影响
      })
    })
  }
  /**
   * @param {*} title
   * @param {*} link
   * @param {*} imgUrl
   * @param {*} desc
   */
  weixinShare(title, link, imgUrl, desc) {
    this.weixinInit()
    wx.ready(() => {
      wx.hideMenuItems({
        menuList: ['menuItem:copyUrl', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
      })
      // 分享到朋友圈
      wx.onMenuShareTimeline({
        title: title, // 分享标题
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () {},
        cancel: function () {}
      })
      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {},
        cancel: function () {}
      })
      // 分享到QQ
      wx.onMenuShareQQ({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接
        imgUrl: imgUrl, // 分享图标
        success: function () {},
        cancel: function () {}
      })
      // 分享到腾讯微博
      wx.onMenuShareWeibo({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接
        imgUrl: imgUrl, // 分享图标
        success: function () {},
        cancel: function () {}
      })
      // 分享到QQ空间
      wx.onMenuShareQZone({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接
        imgUrl: imgUrl, // 分享图标
        success: function () {},
        cancel: function () {}
      })
    })
  }
  recommendClick(id) {
    recommendClick({
      rid: id,
      channel: {
        channel: localStorage.getItem('is_wx')
      }
    })
  }
  formCheck(value, arg = { checkNull: true }) {
    if (arg.checkNull !== false) {
      arg.checkNull = true
    }
    let result = {
      checked: true,
      error: ''
    }
    // 非空判断 默认不为空
    if (arg.checkNull && (typeof value === 'undefined' || value === null || value === '')) {
      result.checked = false
      result.error = '不能为空'
      return result
    }
    // 类型判断 默认不做类型判断
    let checkType = arg.checkType || null
    if (checkType === 'number') {
      result.checked = value === '' || this.numberTest(value)
      result.error = result.checked ? '' : '必须为数字'
    } else if (checkType === 'idCard') {
      result.checked = value === '' || idCard.verify(String(value))
      result.error = result.checked ? '' : '无效证件号'
    } else if (checkType === 'phoneNumber') {
      result.checked = value === '' || this.phoneNumberTest(value)
      result.error = result.checked ? '' : '号码无效'
    } else if (checkType === 'email') {
      result.checked = value === '' || this.emailTest(value)
      result.error = result.checked ? '' : '无效邮箱'
    } else if (checkType === 'money') {
      result.checked = this.moneyTest(value)
      result.error = result.checked ? '' : '无效的金钱数值'
    }
    return result
  }
  numberTest(value) {
    // 暂时只能对number string boolean 类型进行判断
    if (['number', 'string', 'boolean'].indexOf(typeof value) === -1) {
      return false
    }
    value = typeof value === 'number' ? value.toString() : typeof value === 'boolean' ? (value ? 1 : 0) : value
    // 数字，首位克为0
    let regular = /^\+?[0-9]*$/
    return regular.test(value)
  }
  ossImgShow(value) {
    // oss图片显示
    let imgUrl = []
    let url = 'https://1487726325366913.cn-shenzhen.fc.aliyuncs.com/2016-08-15/proxy/OSS_Token/oss_download_sign/?bucket_name=inquiry-ol'
    if (value && value.length !== 0) {
      for (let i = 0; i < value.length; i++) {
        url += `&file_name=${value[i]}`
      }
    }
    window.axiosBaseApi
      .get(url)
      .then(function (ress) {
        if (ress.status === 200) {
          for (let k = 0; k < ress.data.signs.length; k++) {
            if (ress.data.signs[k].key !== '""') {
              imgUrl.push(
                `https://inquiry.ynhdkc.com/${ress.data.signs[k].key}?Expires=${ress.data.time_stamp}&OSSAccessKeyId=${ress.data.accessKeyId}&Signature=${ress.data.signs[k].sign}`
              )
            }
          }
        } else {
          alert(ress.statusText)
        }
      })
      .catch((e) => {
        alert(e)
      })
    return imgUrl
  }
  ossPrivateImgShow(value) {
    // oss图片显示
    let imgUrl = []
    let url = 'https://1487726325366913.cn-shenzhen.fc.aliyuncs.com/2016-08-15/proxy/OSS_Token/oss_download_sign/?bucket_name=dyt-private'
    if (value && value.length !== 0) {
      for (let i = 0; i < value.length; i++) {
        url += `&file_name=${value[i]}`
      }
    }
    window.axiosBaseApi
      .get(url)
      .then(function (ress) {
        if (ress.status === 200) {
          for (let k = 0; k < ress.data.signs.length; k++) {
            if (ress.data.signs[k].key !== '""') {
              imgUrl.push(
                `https://privatefile.ynhdkc.com/${ress.data.signs[k].key}?Expires=${ress.data.time_stamp}&OSSAccessKeyId=${ress.data.accessKeyId}&Signature=${ress.data.signs[k].sign}`
              )
            }
          }
        } else {
          alert(ress.statusText)
        }
      })
      .catch((e) => {
        alert(e)
      })
    return imgUrl
  }
  phoneNumberTest(value) {
    // 只对number string 类型进行判断
    if (['number', 'string'].indexOf(typeof value) === -1) {
      return false
    }
    value = typeof value === 'number' ? value.toString() : value
    // 数字，首位克为 0
    let regular = /^1\d{10}$/
    return regular.test(value)
  }
  moneyTest(value) {
    if (['number', 'string'].indexOf(typeof value) === -1 || parseFloat(value) === 0) {
      return false
    }
    let regular = /^\d+\.?\d{0,2}$/
    return regular.test(value)
  }
  emailTest(value) {
    let regular = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
    return regular.test(value)
  }
  getCookie(name) {
    let strcookie = document.cookie // 获取 cookie 字符串
    let arrcookie = strcookie.split('; ') // 分割
    // 遍历匹配
    for (let i = 0; i < arrcookie.length; i++) {
      let arr = arrcookie[i].split('=')
      if (arr[0] === name) {
        return arr[1]
      }
    }
    return ''
  }
  // 挂号预约时间操作
  computeDay({ format = 'number', days = 0 } = { format: 'number', days: 0 }) {
    let nowDate = new Date()
    if (days && days !== 0) {
      nowDate.setDate(nowDate.getDate() + days)
    }
    return this.formatDate({
      date: nowDate.getTime(),
      format: format
    })
  }
  formatDate({ date = null, format = 'number', days = 0 } = { date: null, format: 'number', days: 0 }) {
    date = date ? new Date(date) : new Date()
    let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : String(0) + (date.getMonth() + 1)
    let day = date.getDate() > 9 ? date.getDate() : String(0) + date.getDate()
    if (format === 'yy-mm-dd') {
      return date.getFullYear() + '-' + month + '-' + day
    } else if (format === 'yy/mm/dd') {
      return date.getFullYear() + '/' + month + '/' + day
    } else if (format === 'yy-mm-dd hh:mm') {
      return date.getFullYear() + '-' + month + '-' + day + ' ' + date.getHours() + ':' + date.getMinutes()
    } else {
      return date.getTime()
    }
  }
  minusDate(d1 = new Date(), d2 = new Date()) {
    return d1.getTime() - d2.getTime()
  }
  intervalDays(dateStr) {
    let startTime = new Date(Date.parse(dateStr.replace(/-/g, '/'))).getTime()
    let endTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
    let dates = Math.ceil(Math.abs(startTime - endTime) / (1000 * 60 * 60 * 24))
    return dates
  }
  /**
   * 计算对应的星期几，如果是最近几日显示友好时间 - by hejikun
   * @param {String} dateStr 要处理的日期字符串，格式 '2018-01-01'
   */
  computeWeek(dateStr) {
    const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    const intervalDay = (dateStr) => {
      let startTime = new Date(Date.parse(dateStr.replace(/-/g, '/'))).getTime()
      let endTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      let dates = Math.ceil(Math.abs(startTime - endTime) / (1000 * 60 * 60 * 24))
      return dates
    }
    let week = weeks[new Date(dateStr).getDay()]
    let intervalDays = intervalDay(dateStr)
    switch (intervalDays) {
      case 0:
        week = '今天'
        break
      case 1:
        week = '明天'
        break
      case 2:
        week = '后天'
        break
      default:
        break
    }
    return week
  }
  setSchedule(arg) {
    let weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    // 计算号源的今天、明天
    let arry = arg
    let intervalDay = function (dateStr) {
      let startTime = new Date(Date.parse(dateStr.replace(/-/g, '/'))).getTime()
      let endTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      let dates = Math.ceil(Math.abs(startTime - endTime) / (1000 * 60 * 60 * 24))
      return dates
    }
    if (Array.isArray(arry)) {
      arry.forEach(function (arry) {
        arry.week = weeks[new Date(arry.sch_date).getDay()]
        let intervalDays = intervalDay(arry.sch_date)
        arry.day = ''
        if ([0, 1].indexOf(intervalDays) !== -1) {
          if (intervalDays === 0) {
            arry.day = '今天'
          } else if (intervalDays === 1) {
            arry.day = '明天'
          } else if (intervalDays === 2) {
            arry.day = '后天'
          }
        }
      })
    }

    return arry
  }
  getTMap(key) {
    /* eslint-disable */
    return new Promise(function (resolve, reject) {
      window.init = function () {
        resolve(qq)
      }
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = `https://map.qq.com/api/js?v=2.exp&callback=init&key=${key}&libraries=drawing,geometry,autocomplete,convertor`
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
  authorization() {
    if (!config.userDetail) {
      return
    }
    if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
      return
    }
    let form = config.from
    let subscribe = config.userDetail.subscribe
    let newOpenid = config.userDetail.new_openid
    let newSubscribe = 1
    let noNeedLead = config.noNeedLead
    if (!noNeedLead && !form) {
      if (subscribe || newSubscribe) {
        let leadNewMp = config.userDetail.lead_new_mp
        if (subscribe && !newSubscribe && leadNewMp) {
          window.location.href = '/new_attention2'
        }
        return
      }
      const iatDiff = new Date().getTime() - config.userDetail.iat * 1000
      if (!newSubscribe) {
        // if (iatDiff > 60000) {
        //   localStorage.removeItem('authtoken')
        //   location.reload()
        // }
        window.location.href = '/static/attention.html' + window.location.search
        return
      }
      window.location.href = '/lead_attention'
    }
  }
}

/**
 * @module utils
 * @namespace utils
 * @desc
 * > 这是一个公用方法库实例
 * @see {@link Utils}
 */
const utils = new Utils()
export default utils
